import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { ListedCompanyVehicleSetup } from 'contracts/CompanyVehicleSetups';

const { Types, Creators } = createActions(
  {
    request: ['query', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'LIST_COMPANY_VEHICLE_SETUPS_',
  }
);

export interface ListCompanyVehicleSetupsState {
  data: ListedCompanyVehicleSetup[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ListCompanyVehicleSetupsRequestAction {
  query?: Record<string, any>;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: ListedCompanyVehicleSetup[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ListCompanyVehicleSetupsState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ListCompanyVehicleSetupsState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (
  state: ListCompanyVehicleSetupsState,
  action: SuccessAction
) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (
  state: ListCompanyVehicleSetupsState,
  action: FailureAction
) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ListCompanyVehicleSetupsState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const listCompanyVehicleSetups = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ListCompanyVehicleSetupsTypes = Types;
export const ListCompanyVehicleSetupsActions = Creators;
